import React from 'react';
import { getAppHomePath } from '../constants/navigation';
import EnterpriseManagementPage from './EnterpriseManagementPage';

const Enterprises = () => (
  <EnterpriseManagementPage
    breadcrumbs={[{ label: 'Início', to: getAppHomePath() }, { label: 'Empreendimentos' }]}
  />
);

export default Enterprises;
